module.exports = __webpack_public_path__ + "img/page-networks-qrcode-car.4d4a4b1b.png";